import React, { useState, useRef, useEffect } from 'react'
import Button from '@components/Button'
import Divider from '@components/Divider'
import Text from '@components/Text'
import {
    COLORS,
    BUTTON_SIZE,
    BUTTON_TYPE,
    DIVIDER_SIZE,
    TEXT_SIZES,
} from '@helpers/constants'
import ExerciseBlock from '@components/ExerciseBlock'
import { getImageSrc } from '@helpers/utilities'
import BlockRenderer from '@views/BlockRenderer'

const WordExplanation = (props) => {
    const {
        id,
        type = '',
        name,
        preamble,
        words,
    } = props

    if (!words) return null

    const [selectedWordIndex, setSelectedWordIndex] = useState(0)
    const [showExplanation, setShowExplanation] = useState(false)
    const [height, setHeight] = useState(100)

    useEffect(() => {
        setSelectedWordIndex(0)
        setShowExplanation(false)
    }, [id])

    const setContentHeight = (ref) => {
        if (ref) {
            setHeight(Math.ceil(ref.clientWidth / 3))
        }
    }
    const word = words[selectedWordIndex]?.word
    const wordExplanation = words[selectedWordIndex]?.explanation
    const imageUrl = words[selectedWordIndex]?.image ? getImageSrc(words[selectedWordIndex].image) : undefined

    return (
        <ExerciseBlock
            name={name}
            preamble={preamble}
        >
            <div>
                <ol className={'flex flex-wrap'}>
                    {words?.map((wordItem, index) => {
                        return (
                            <li key={index} className={'mr-2 mb-2'}>
                                <Button
                                    type={selectedWordIndex === index ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.SECONDARY}
                                    size={BUTTON_SIZE.MEDIUM}
                                    handleClick={() => {
                                      setShowExplanation(false)
                                      setSelectedWordIndex(index)
                                    }}
                                >
                                    {wordItem?.word}
                                </Button>
                            </li>
                        )
                    })}
                </ol>
                <Divider size={DIVIDER_SIZE.SMALL} />
                <div className={'w-full flex items-center p-2 bg-white'}>
                    {(type !== 'toolbox' && !showExplanation) && (
                        <div
                            ref={(element) => setContentHeight(element)}
                            style={{ minHeight: height + 'px'}}
                            className={
                                `flex flex-col ${imageUrl ? 'w-2/3' : 'w-full '} justify-center items-center text-center`
                            }
                        >
                            <Text size={TEXT_SIZES.XLARGE}>{word}</Text>
                            <Divider size={DIVIDER_SIZE.SMALL} />
                            <Button
                                type={BUTTON_TYPE.PRIMARY}
                                size={BUTTON_SIZE.MEDIUM}
                                backgroundColor={
                                    COLORS.PRIMARY_GREEN.BACKGROUND
                                }
                                textColor={COLORS.WHITE.TEXT}
                                handleClick={() => setShowExplanation(true)}
                            >
                                Visa info
                            </Button>
                        </div>
                    )}
                    {(type === 'toolbox' || showExplanation) && (
                        <div
                            style={{ minHeight: height + 'px'}}
                            className={'w-2/3 h-full p-2'}
                        >
                            <Text size={TEXT_SIZES.XLARGE}>{word}</Text>
                            <BlockRenderer content={wordExplanation} />
                        </div>
                    )}
                    {imageUrl && (
                        <div className='w-1/3 self-start'>
                            <div className={'w-full pb-[100%] relative'}>
                                <img
                                    className={'absolute w-full h-full object-cover '}
                                    src={imageUrl}
                                    alt=''
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </ExerciseBlock>
    )
}

export default WordExplanation
